export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker.b21d4f0a.worker.js");
}
